module.exports = __webpack_public_path__ + "img/icon-user.135afba4.svg";